module.exports = __webpack_public_path__ + "static/media/RetornoCancelamento1.01648936.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancRetornoCancelamento/RetornoCancelamento1.png
// module id = 2059
// module chunks = 0